@for (row of displayRows; track row) {
  <div>
    @for (control of row?.controls; track control) {
      <span>
        {{ control.value === 'None' ? '' : control.value }}
      </span>
    }
  </div>
}
